// import dependencies
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ForumPage from './pages/ForumPage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import CalendarPage from './pages/CalendarPage'
import ContactPage from './pages/ContactPage';
import HomePage from './pages/HomePage';
import Nav from './components/Nav';
import ScrollToTop from "./components/ScrollToTop";

import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <div id="header">
        <header className="App-header">
          <h1 className="header-text">Midcoast Socialist Coalition 
            {/* <img src={logo} className="App-logo" alt="logo" /> */}
          </h1>
        </header>
      </div>
        <ScrollToTop />
        <Nav />

        <main>
          <section className="App-article">
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} /> 
                <Route path="/blog" element={<BlogPage />} /> 
                <Route path="/calendar" element={<CalendarPage />} /> 
                <Route path="/forum" element={<ForumPage />} />

            </Routes>
          </section>
        </main>
        <div id="body"></div>
        <div id="footer">
        <footer>
          <p><cite>Can use the footer to list socials and whatnot</cite></p>
        </footer>  
        </div>     
        </BrowserRouter>
      </div>
    );
  }

export default App;
